import React from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router";
import { CurrencyRate } from "./CurrencyRate.interface";
import { currencyData } from "./currenct.data";

const TableHeader: React.FC = () => (
  <thead>
    <tr className="border-b-2 border-yellow-500">
      <th scope="col" className="p-3 text-left">Currency</th>
      <th scope="col" className="p-3 text-left">Sell Price</th>
      <th scope="col" className="p-3 text-left">Buy Price</th>
    </tr>
  </thead>
);

const TableRow: React.FC<{ currency: CurrencyRate }> = ({ currency }) => (
  <tr className="odd:bg-gray-800 even:bg-gray-700">
    <td className="flex items-center gap-2 p-3">
      <Icon icon={currency.icon} width={25} aria-hidden="true" />
      <span>{currency.name}</span>
    </td>
    <td className="p-3">{currency.sell}</td>
    <td className="p-3">{currency.buy}</td>
  </tr>
);

const TableFooter: React.FC = () => (
  <tfoot>
    <tr>
      <th colSpan={3} className="p-3 text-center">
        <Link
          to="market/black-market-in-egypt"
          className="text-primary hover:underline"
          aria-label="View more black market currency rates in Egypt"
        >
          View more rates
        </Link>
      </th>
    </tr>
  </tfoot>
);

const BlackMarketRates: React.FC = () => (
  <section
    className="mb-6 px-4 sm:px-0"
    aria-labelledby="black-market-rates-heading"
  >
    <h3
      id="black-market-rates-heading"
      className="dark:text-primary text-tealGreen text-center text-xl font-bold mb-4"
    >
      Black Market Rates
    </h3>

    <div className="overflow-x-auto">
      <table
        className="table-auto w-full text-sm text-left bg-slateGray text-white rounded-2xl overflow-hidden min-w-[300px]"
        role="table"
        aria-label="Black market currency exchange rates"
      >
        <TableHeader />
        <tbody>
          {currencyData.map((currency, idx) => (
            <TableRow key={idx} currency={currency} />
          ))}
        </tbody>
        <TableFooter />
      </table>
    </div>
  </section>
);

export default BlackMarketRates;
